import React from 'react';

export default (
	<svg
		width="34"
		height="34"
		viewBox="0 0 34 34"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M21.833 0.5V11.0078H11.167V21.5146H0.5V33.5H33.5V0.5H21.833ZM32.5 32.5H1.5V22.5146H12.167V12.0078H22.833V1.5H32.5V32.5Z"
			fill="#663D00"
			stroke="black"
		/>
	</svg>
);
